import { render, staticRenderFns } from "./DwOrder.vue?vue&type=template&id=adca8e44&scoped=true&"
import script from "./DwOrder.vue?vue&type=script&lang=js&"
export * from "./DwOrder.vue?vue&type=script&lang=js&"
import style0 from "./DwOrder.vue?vue&type=style&index=0&id=adca8e44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adca8e44",
  null
  
)

export default component.exports